const findBounds = (collection) => {
  const bounds = collection.map(({ attributes: { latitude, longitude } }) => {
    if (!latitude || !longitude) {
      return null
    }

    return L.latLng(latitude, longitude)
  }).filter(Boolean)

  return L.latLngBounds(bounds)
}

export {
  findBounds
}
